const DELETE_WORKFLOW_BY_ID = 'DELETE_WORKFLOW_BY_ID';
export default DELETE_WORKFLOW_BY_ID;